<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  invite: unknown
  showCheckbox?: boolean
  selected?: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:selected', val: boolean): void
  (e: 'click'): void
}>()

const isDisabled = computed(() => !!props.disabled)

function toggleSelected() {
  if (isDisabled.value) return
  emit('update:selected', !props.selected)
}
</script>

<template>
  <v-card class="event-card rounded-lg" variant="flat" :disabled="isDisabled">
    <v-card-text class="px-4 py-4">
      <div class="d-flex ga-3 align-start">
        <!-- Checkbox (modo seleção) -->
        <div v-if="showCheckbox" class="pt-1">
          <v-checkbox
            :model-value="!!selected"
            :disabled="isDisabled"
            hide-details
            density="compact"
            @update:model-value="toggleSelected"
            @click.stop
          />
        </div>

        <!-- Conteúdo -->
        <div class="flex-grow-1 min-w-0">
          <div class="min-w-0">
            <slot name="name" />
          </div>

          <div class="mt-2">
            <slot name="invitecontent" />
          </div>

          <div class="mt-3">
            <slot name="links" />
          </div>
        </div>
      </div>
    </v-card-text>

    <!-- Clique no card inteiro seleciona (quando checkbox ativo) -->
    <div
      v-if="showCheckbox"
      class="event-card__overlay"
      :class="{ 'event-card__overlay--disabled': isDisabled }"
      @click="toggleSelected"
    />
  </v-card>
</template>

<style scoped>
.event-card {
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.event-card__overlay {
  position: absolute;
  inset: 0;
  cursor: pointer;
}

.event-card__overlay--disabled {
  cursor: default;
}

.min-w-0 {
  min-width: 0;
}
</style>
